<template>
  <vue-scroll class="login-page align-vertical">
    <div class="form-wrapper align-vertical-middle">
      <div class="form-box card-base card-shadow--medium">
        <img class="image-logo" :src="logoURL" alt="logo"/>

        <form @submit.prevent="submit">
          <el-input v-model="password" placeholder="Enter new password" type="password">
            <template slot="prefix">Password</template>
          </el-input>
          <span class="pw-error" v-if="password.length && !passwordValid">
            Password must be at least 5 characters
          </span>
          <el-input v-model="confirmPass" placeholder="Confirm Password" type="password">
            <template slot="prefix">Confirm password</template>
          </el-input>
          <span class="pw-error" v-if="confirmPass.length && !confirmValid">
            Passwords do not match
          </span>
          <div class="flex text-center center pt-20 pb-10">
            <el-button native-type="submit" class="login-btn">
              Reset Password
            </el-button>
          </div>
        </form>

      </div>
    </div>
  </vue-scroll>
</template>

<script>

  import feathersClient from "../../../feathers/feathers-client";

  export default {
    name: 'ResetPassword',
    data() {
      return {
        password: '',
        confirmPass: '',
        passwordValid: false,
        confirmValid: false,
        authToken: '',
        email: ''
      }
    },
    computed: {
      logoURL(){
        return this.$store.state.branding.logoOnlyURL;
      }
    },
    watch: {
      password() {
        this.passwordValid = this.password.length >= 5;
        this.confirmValid = this.confirmPass === this.password;
      },
      confirmPass(){
        this.confirmValid = this.confirmPass === this.password;
      }
    },
    methods: {
      submit() {
        if(this.passwordValid && this.confirmValid){
          console.log('ready to reset');
          const resetService = feathersClient.service('forgot-password');
          resetService.update(null, {
            email: this.email,
            password: this.password,
            token: this.authToken
          }).then( (res) => {
            this.$notify({
              title: 'Success',
              message: res,
              type: 'success'
            });
            this.$router.push('/login');

						// ⭐️ `Forgot Password Reset` user event log ⭐️ //
/*						this.$store.dispatch('userEvents/create', {
							event: "Password Reset",
							type: "Forgot",
						});*/
          }).catch( (e) => {
            this.$notify({
              title: 'Error',
              message: e,
              type: 'error'
            });
          });
        } else{
          this.$notify({
            title: 'Error',
            message: 'The fields are not valid',
            type: 'error'
          });
        }
      }
    },
    mounted() {
      //check context of route so we can show a modal if appropriate
      const urlParams = new URLSearchParams(window.location.search);
      this.email = urlParams.get('email').replace('%40', '@');
      this.authToken = urlParams.get('token');
    }
  }
</script>

<style lang="scss">
  @import '../../../assets/scss/_variables';

  .login-btn,
  .social-btn {
    width: 160px;

    &.google {
      margin-bottom: 10px;
      background-color: #d73d32;
      color: white;

      &:hover {
        border-color: #d73d32;
      }
    }

    &.facebook {
      background-color: #3f5c9a;
      color: white;

      &:hover {
        border-color: #3f5c9a;
      }
    }
  }

  .pw-error{
    font-size: 8pt;
    color: $voxo-orange;
  }

  @media (max-width: 768px) {
    .layout-container .container .view.forgot-password-page {
      margin-left: -5px;
      margin-right: -5px;
      max-width: calc(100% + 10px);
    }
  }
</style>
